import { formatTime, getBrowserTimezone } from '../../lib/DateTime.js';

const ViewTimeZone = ({ className, bookableResources }) => {
    const browserTz = getBrowserTimezone();
    let showTz = false;

    if (!bookableResources) {
        return null;
    }

    for (const resource of bookableResources) {
        if (resource.timezone !== browserTz) {
            showTz = true;
            break;
        }
    }

    if (!showTz) {
        return null;
    }

    return (
        <div className={className}>
            Events are shown in your local time zone ({browserTz})
        </div>
    );
};

export default ViewTimeZone;
